import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { IconButterflyMono } from '@xing-com/icons';
import { Container } from '@xing-com/layout-primitives';
import { mediaConfined, mediaSmallOrTiny } from '@xing-com/layout-tokens';
import {
  scale120,
  scale150,
  scale190,
  scale220,
  spaceL,
  spaceS,
  spaceXL,
  spaceXXL,
  xdlColorText,
} from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

import backgroundSmall from './assets/discovered-background-small.svg';
import backgroundWide from './assets/discovered-background-wide.svg';

const DiscoverButton = styled(Button)`
  width: fit-content;
`;

const DiscoverButtonContent = styled.div`
  display: flex;
  align-items: center;
`;

const ContainerCustom = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: ${scale150} ${scale120};

  @media ${mediaSmallOrTiny} {
    gap: ${spaceXL};
    padding: ${scale150} ${spaceXL};
    background-image: url(${backgroundSmall});
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: ${spaceL};
  }
  @media ${mediaConfined} {
    gap: ${spaceXXL};
    padding: ${scale220} ${scale190};
    background-image: url(${backgroundWide});
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: ${spaceL};
  }
`;

const HeadlineText = styled(Headline)`
  margin: 0;
  color: ${xdlColorText};
`;

const Icon = styled(IconButterflyMono)`
  margin-right: ${spaceS};
`;

export const Styled = {
  DiscoverButton,
  DiscoverButtonContent,
  ContainerCustom,
  HeadlineText,
  Icon,
};
